import { css } from "lit";

export const reorderableStyles = css`
  .drag-handle {
    width: 40px;
    cursor: grab;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--sds-color-icon-default-secondary);
    transition: color 0.2s ease;
    touch-action: none;
    user-select: none;
  }

  .drag-handle:hover {
    color: var(--sds-color-text-default-default);
  }

  .drag-handle:active {
    cursor: grabbing;
  }

  th.col-drag-handle {
    width: 40px;
    padding: var(--sds-size-space-400) var(--sds-size-space-200);
  }

  td.col-drag-handle {
    width: 40px;
    padding: var(--sds-size-space-400) var(--sds-size-space-200);
  }

  tr[dragging],
  .tile[dragging] {
    opacity: 0.4;
  }

  tr[drop-above],
  .tile[drop-above] {
    border-top: 2px solid var(--primary-color, #007bff);
  }

  tr[drop-below],
  .tile[drop-below] {
    border-bottom: 2px solid var(--primary-color, #007bff);
  }
`;
